// System
import { useDispatch } from 'react-redux';
import { Stack, Typography, Button, Link } from '@mui/material';

// Hooks
import useResponsive from '@Hooks/shared/useResponsive';
import { useCreateProvider } from '@Modal/hooks/providers/useCreateProvider';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';

// Components
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { useProvidersTable } from '@Modal/hooks/providers/useProvidersTable';

export const ProvidersTitle: React.FC = () => {
  const isDesktop = useResponsive('up', 'sm');
  const { userPermissions } = useAuthorization();
  const permissionToManageProviders = userPermissions?.includes('CAN_MANAGE_PROVIDERS');
  const dispatch = useDispatch();
  const { setShowCreateProviderForm } = useCreateProvider();
  const handleOpenCreateProviderModal = () => dispatch(setShowCreateProviderForm(true));
  const { providersTableFilters, handleClearProvidersTableFilters } = useProvidersTable();
  const objectVals = Object.values(providersTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);

  return (
    <AtLocator type="container" name="customerListTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        <Stack direction="row" alignItems="center" justifyContent="flex-start" gap="10px">
          <Typography variant="h3">Providers</Typography>
        </Stack>
        <Stack direction="row" gap="10px">
          <AtLocator type="button" name="clearFilters">
            <Button
              size="large"
              variant="contained"
              disabled={disabled}
              onClick={handleClearProvidersTableFilters}
            >
              Clear filters
            </Button>
          </AtLocator>
          {permissionToManageProviders && (
            <AtLocator type="button" name="CreateVehicle">
              <Button
                sx={{ width: !isDesktop ? 240 : null }}
                size="large"
                variant="contained"
                onClick={handleOpenCreateProviderModal}
              >
                Add provider
              </Button>
            </AtLocator>
          )}
        </Stack>
      </Stack>
    </AtLocator>
  );
};
